// libraries
import type { DealXgDetailsState, StateTree } from '@makemydeal/dr-dash-types';
import type { ActivityName, ActivityState } from '@makemydeal/dr-dpm-client';

export const getDealXgDetailsState = (state: StateTree): DealXgDetailsState => {
    return state.dealXgDetails || ({} as any);
};

export const getGlobalCustomerId = (state: StateTree) => {
    return getDealXgDetailsState(state).globalCustomerId || '';
};

export const getRedirectionLink = (state: StateTree) => {
    return getDealXgDetailsState(state).redirectionLink || '';
};

export const getOrderDetailsLink = (state: StateTree) => {
    return getDealXgDetailsState(state).orderDetailsLink || '';
};

export const getIldpDetailsLink = (state: StateTree) => {
    return getDealXgDetailsState(state).ildpDetailsLink || '';
};

export const getEcommerceOrderNumber = (state: StateTree): string => {
    return getDealXgDetailsState(state).omsOrderNumber || '';
};

export const getIsEcommerceDeal = (state: StateTree): boolean => {
    return Boolean(getEcommerceOrderNumber(state)) || false;
};

export const getTenantId = (state: StateTree): string => {
    return getDealXgDetailsState(state).tenantId || '';
};

export const getDpmStateByActivity = (state: StateTree, activity: ActivityName): ActivityState | undefined => {
    const activityMilestones = state.activityMilestones;
    const lowerCaseName = activity.charAt(0).toLowerCase() + activity.slice(1);

    return activityMilestones?.[lowerCaseName]?.state;
};

export const getLatestPushToDmsPlus = (state: StateTree) => {
    return getDealXgDetailsState(state).latestPushToDmsPlus || undefined;
};

export const getAutoLeadId = (state: StateTree) => {
    return getDealXgDetailsState(state).autoLeadId || '';
};
